<template>
  <div
    v-if="hasMoreThanOneResponsibility"
    class="section-visibility-responsibilities"
  >
    <div
      v-if="!isCompact"
      class="dark-multiselect px-3 pt-2 pb-1"
    >
      <b-form-group class="group-sidebar-element">
        <div class="form-label">
          <label>{{ $tc('configuration.modal.responsibility', 2) }}</label>
        </div>
        <vt-combo-select
          v-model="responsibilitySelected"
          :allow-empty="false"
          qa="diagnosis-responsibilities-sidebar-combo-selection"
          :options="responsibilities"
          track-by="code"
          label="translatedName"
          name="responsibilities-combo"
          class="multiselect--sidebar"
          @input="$emit('update-responsibilities', responsibilitySelected)"
        />
      </b-form-group>
    </div>
    <div
      v-else
      id="visibility-responsibilities"
      class="section-visibility-responsibilities-compact group dark-multiselect"
    >
      <div class="check-parent d-flex align-items-center justify-content-center py-2 px-2">
        <div class="px-2">
          <i
            class="fal fa-user-friends white"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'visibility-responsibilities'"
        placement="rightbottom"
        :container="'visibility-responsibilities'"
        class="popover-sections"
      >
        <div class="menu-popover pop-module check-popover">
          <div
            class="d-flex align-items-center"
          >
            <div class="title d-flex flex-column w-100 px-3 pt-2 pb-3">
              <div class="form-label">
                <label>{{ $tc('configuration.modal.responsibility', 2) }}</label>
              </div>
              <vt-combo-select
                v-model="responsibilitySelected"
                :allow-empty="false"
                qa="diagnosis-responsibilities-sidebar-combo-selection"
                :options="responsibilities"
                track-by="code"
                label="translatedName"
                name="responsibilities-combo"
                class="multiselect--sidebar"
                @input="$emit('update-responsibilities', responsibilitySelected)"
              />
            </div>
          </div>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<script>
import { diagnosisResponsibilityService } from '@/modules/diagnosisModule/services/DiagnosisResponsibilityService'

export default {
    name: 'SectionVisibilityResponsibilities',
    props: {
        sidebarStore: { type: Object },
        isCompact: { type: Boolean, default: false }
    },
    data() {
        return {
            viewResponsibilitiesCombo: this.sidebarStore.state.config.responsibility,
            responsibilities: [],
            responsibilitySelected: null
        }
    },
    computed: {
        hasMoreThanOneResponsibility() {
            return this.responsibilities.length > 1
        }
    },
    async mounted() {
        if (!this.responsibilities.length) {
            await this.loadResponsibilities()
        }
        if (this.hasMoreThanOneResponsibility) {
            this.findResponsibilityOrFirstPreselection(this.viewResponsibilitiesCombo)
        } else {
            this.sidebarStore.setResponsibility(null)
        }
        this.$eventHub.$emit('diagnosis-sidebar-mounted', true)
    },
    methods: {
        findResponsibilityOrFirstPreselection(responsibility) {
            const responsibilityExists = this.responsibilities.some((item) => item.code === responsibility?.code)
            if (!responsibilityExists) {
                this.responsibilitySelected = this.responsibilities[0]
                this.sidebarStore.setResponsibility(this.responsibilitySelected)
            } else {
                this.responsibilitySelected = responsibility
            }
        },
        async loadResponsibilities() {
            const responsibilites = await this.$_toCallSecure(diagnosisResponsibilityService.getResponsibilities())
            this.responsibilities = responsibilites ?? []
        }
    }
}
</script>

<style lang="scss" scoped>
    .section-visibility-responsibilities {
        label {
            font-size:font-size(very-small);
            color: vt-color(white)
        }
        background: vt-color(sidebar-visibility-bg);
    }

    .section-visibility-responsibilities-compact .check-parent {
        background: vt-color(sidebar-visibility-bg);
        cursor: pointer;
    }

    .section-visibility-responsibilities-compact .section-header {
        display: none;
    }

    .section-visibility-responsibilities-compact .switch-label {
        font-size: font-size(very-small);
        color: vt-color(dark-text);
    }
    .section-visibility-responsibilities-compact .switch {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }
    .section-visibility-responsibilities-compact .switch::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }
    .section-visibility-responsibilities-compact input[type="checkbox"]:checked + .switch::after {
        transform: translateX(14px);
    }
    .section-visibility-responsibilities-compact input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }
    .section-visibility-responsibilities-compact .offscreen {
        position: absolute;
        left: -9999px;
    }
    .section-visibility-responsibilities-compact .menu-popover {
        width: 200px;
        background: vt-color(sidebar-visibility-bg);
    }

    .check-parent:hover {
        background-color: vt-color(primary);
    }

    .check-parent .title span {
        font-size: font-size(very-small);
        color: #707070;
        margin-left: 4px;
    }

</style>
